import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const BoxesRow = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
`;

export const BoxesValue = styled.div`
  font-family: ${defaultTheme.fonts.title};
  font-size: 1.2rem;
  font-weight: 700;
  color: ${defaultTheme.colors.black};
`;

export const BoxesLabel = styled.div`
  font-size: 0.75rem;
  color: ${defaultTheme.colors["gray-300"]};
`;

export const Balance = styled.span<{ pending: boolean }>`
  font-weight: 700;
  color: ${({ pending }) => (pending ? defaultTheme.colors.danger : defaultTheme.colors.success)};
`;

export const LimitationNote = styled.p`
  font-size: 0.75rem;
  color: ${defaultTheme.colors["gray-200"]};
  margin-top: 8px;
`;
